export const PIT_EVENT = {
  Deposit: "Deposit",
  Borrow: "Borrow",
  RepayBorrow: "RepayBorrow",
  Withdraw: "Withdraw",
};
